'use strict';

var AbstractFormView = require('components/common/views/abstract_form_view');
var AbstractTableView = require('components/common/views/abstract_table_view');
var App = require('app');
var AppState = require('app_state');
var BaseDeviceListView = require('components/devices/views/common/base_device_list_view');
var FilterDialogView = require('components/devices/views/common/filter_dialog_view');
var i18n = require('utils/i18n');
var Misc = require('utils/misc');
var OOP = require('utils/oop');
var ValueSelectDialog = require('components/devices/views/common/value_selection_dialog_view');
var BarController = require('components/common/widgets/controller/bar_controller');

var GatewayReportView = Marionette.LayoutView.extend({
    template: require('components/profile/templates/report_layout'),

    events: {
        'click .js-reset-filter': function (e) {
            e.preventDefault();
            AppState.setURLParameter({ filter: '{}' }, 'update');
            this.options.controller.GatewayReportView();
        },
        'click .js-edit-filter': function (e) {
            this.showFilter(e);
        },
    },

    initialize: function (options) {
        var filterObj = AppState.getURLParameter(['filter']).filter;
        this.filter = {
            filterObj: filterObj && JSON.parse(filterObj),
        };
    },

    serializeData: function () {
        var data = AbstractFormView.prototype.serializeData.apply(this, arguments);
        data.filter = this.filter.filterObj || {};
        data.showFilter = Misc.hasFilterSet(data.filter);
        return data;
    },

    showFilter: function (e) {
        var self = this;
        e.preventDefault();
        e.stopPropagation();
        App.showModal(
            new FilterDialogView({
                filter: self.filter.filterObj,
                cb: function (filter) {
                    App.hideModal();
                    AppState.setURLParameter({ filter: JSON.stringify(filter) }, 'update');
                    self.options.controller.GatewayReportView();
                },
            })
        );
    },

    regions: {
        overview: '#js-overview',
        table: '#js-table',
    },

    onShow: function () {
        var self = this;
        if (this.collection.length > 0) {
            this.options.showFilter = function (e) {
                self.showFilter(e);
            };
            this.showChildView('overview', new SummaryView(this.options.average_values));
            this.showChildView('table', new DataView(_.extend(this.options, { filter: this.filter })));
        }
    },
});

var SummaryView = Marionette.ItemView.extend({
    template: require('components/profile/templates/overview'),
    initialize: function (options) {
        this.totalGateways = options.offline + options.online;

        this.bytesMaxTotal = 0;
        this.bytesMaxAverage = 1;

        var self = this;
        _.each(options.bytes, function (byte, idx) {
            if (idx < 3) {
                self.bytesMaxAverage = Math.max(self.bytesMaxAverage, byte);
            } else {
                self.bytesMaxTotal = Math.max(self.bytesMaxTotal, byte);
            }
            options.bytes[idx] = Math.max(byte, 0);
        });

        _.each(options.disturbed, function (d, idx) {
            options.disturbed[idx] = Math.max(options.disturbed[idx], 0);
        });
    },

    serializeData: function () {
        var data = {
            intervals: [],

            online: this.options.online,
            offline: this.options.offline,

            data_transfer_total: [],
        };

        var self = this;
        var intervalNames = [i18n.TR('Gestern'), i18n.TR('Letzte 7 Tage'), i18n.TR('Letzte 30 Tage')];

        _.each(this.options.disturbed, function (disturbedGatewayCount, idx) {
            data.intervals.push({
                count: disturbedGatewayCount,
                name: intervalNames[idx],
                config: {
                    percent: Math.round((100 * disturbedGatewayCount) / self.totalGateways),
                    color: AppState.style[1],
                },
            });
        });

        data.data_transfer = BarController.initData({
            dataSets: [this.options.bytes.slice(0, 3), this.options.bytes.slice(3, 6)],
            units: ['B', 'B'],
            title: i18n.TR('Übertragene Bytes'),
            columns: intervalNames,
            legend: [i18n.TR('Pro Gerät pro Tag'), i18n.TR('Insgesamt')],
        });

        data.widgetConfig = {
            percent: Math.round((this.options.online / this.totalGateways) * 100),
            color: AppState.style[1],
        };

        return data;
    },
});

var DataView = OOP.extend(BaseDeviceListView, {
    selectedIdList: undefined,
    enableURLHistory: true,

    columns: [
        { id: 'offline_events', index: 'offline_events', name: i18n.TR('Offline-Ereignisse'), is_selected: false },
        { id: 'data_day', index: 'data_day', name: i18n.TR('Daten/Tag'), is_selected: false },
        { id: 'data_week', index: 'data_week', name: i18n.TR('Daten/Woche'), is_selected: false },
        { id: 'data_month', index: 'data_month', name: i18n.TR('Daten/Monat'), is_selected: false },
        { id: 'online_day', index: 'online_day', name: i18n.TR('Online/Tag'), is_selected: false },
        { id: 'online_week', index: 'online_week', name: i18n.TR('Online/Woche'), is_selected: false },
        { id: 'online_month', index: 'online_month', name: i18n.TR('Online/Monat'), is_selected: false },
    ],

    initialize: function (options) {
        this.controller = this.options.controller;
        this.colConfig = this.options.colConfig || '';
        this.showFilter = this.options.showFilter;

        AbstractTableView.prototype.initialize.apply(this, [this.getTableConfiguration()]);
    },

    events: function () {
        return _.extend({}, BaseDeviceListView.prototype.events(), {
            'click .js-tab-btn-options': 'configureColumns',
            'click .js-tab-btn-filter': function (e) {
                this.showFilter(e);
            },
        });
    },

    setColumnSelectedState: function (indexList) {
        var self = this;
        _.each(self.columns, function (col, idx) {
            self.columns[idx].is_selected = indexList === '' || indexList.indexOf(col.index) != -1;
        });
    },

    configureColumns: function () {
        var self = this;
        App.showModal(
            new ValueSelectDialog({
                title: i18n.TR('Spalten wählen'),
                columns: [{ entries: this.columns }],

                save_cb: function (indexList) {
                    AppState.saveGatewayReportColumns(indexList);

                    self.setColumnSelectedState(indexList);
                    self.refreshTable();
                },
            })
        );
    },

    getSortColumnFunc: function (moreCols) {
        var result = function (c) {
            var id = c.id || c.index;
            if (id.startsWith('#_')) id = id.substring(2, id.length);

            var sortColMap = {
                groups: '',
            };

            var id2 = sortColMap[id];
            if (id2 !== undefined && id2 == '') {
                return undefined;
            }

            return id2 || id;
        };

        return result;
    },

    getCSVLink: function () {
        return (
            '/api/v1/devices/connectionstats?format=csv&limit=0&offset=0&filter=' +
            JSON.stringify(this.options.filter.filterObj || {})
        );
    },

    getTableConfiguration: function () {
        this.setColumnSelectedState(this.colConfig);
        var csvURL = this.getCSVLink();
        var cols = _.filter(this.columns, function (col) {
            return col.is_selected;
        });
        var config = {
            disablePagination: false,
            hasSelectionButtons: true,
            hasRefreshButton: true,
            itemCount: this.options.count,
            itemsPerPage: this.options.itemsPerPage,
            getSortColumn: this.getSortColumnFunc(),
            headingID: 'reportData',
            columns: _.union([{ id: '#_name', name: 'Name' }], cols),
            CSVLink: csvURL,
            listResult: this.options.listResult,

            customButtons: [
                { ButtonIcon: 'fa fa-cog', ButtonID: 'options' },
                { ButtonIcon: 'fa fa-filter', ButtonID: 'filter' },
            ],
        };

        return config;
    },

    updateURL: function () {
        AppState.setURLParameter(
            {
                sortCol: this.currentSortCol,
                sortDesc: this.currentSortDesc,
                page: this.currentPage,
                limit: this.itemsPerPage || AppState.getItemsPerPage(),
                filter: JSON.stringify(this.filter && this.filter.filterObj),
            },
            'extend'
        );
    },
});

module.exports = GatewayReportView;
